module.exports = __webpack_public_path__ + "img/phone-step-one.ffd8b3fa.png";